

// =============================================
// File: src/services/discountService.js
// =============================================

import axiosInstance from './axiosConfig';

const discountService = {
  // Get all discounts
  getDiscounts: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/discounts', { params });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get single discount by ID
  getDiscountById: async (id) => {
    try {
      const response = await axiosInstance.get(`/discounts/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Create new discount
  createDiscount: async (discountData) => {
    try {
      const response = await axiosInstance.post('/discounts', discountData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Update discount
  updateDiscount: async (id, discountData) => {
    try {
      const response = await axiosInstance.put(`/discounts/${id}`, discountData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Delete discount
  deleteDiscount: async (id) => {
    try {
      const response = await axiosInstance.delete(`/discounts/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Validate discount code
  validateDiscountCode: async (code, orderAmount) => {
    try {
      const response = await axiosInstance.post('/discounts/validate', { 
        code, 
        orderAmount 
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Apply discount to order
  applyDiscount: async (orderId, discountCode) => {
    try {
      const response = await axiosInstance.post('/discounts/apply', { 
        orderId, 
        discountCode 
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Get discount usage statistics
  getDiscountStats: async (id) => {
    try {
      const response = await axiosInstance.get(`/discounts/${id}/stats`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Activate/Deactivate discount
  toggleDiscountStatus: async (id, status) => {
    try {
      const response = await axiosInstance.patch(`/discounts/${id}/status`, { status });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default discountService;
